import React from 'react';

const DeleteConfirmationModal = ({
  showDeleteConfirm,
  setShowDeleteConfirm,
  handleDeleteUser
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl p-6 w-full max-w-md">
        <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-4">
          Confirm Deletion
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Are you sure you want to delete user <span className="font-semibold">{showDeleteConfirm.email}</span>? 
          This action cannot be undone.
          {showDeleteConfirm.role === 'superadmin' && (
            <span className="block text-red-600 dark:text-red-400 mt-2">
              Warning: This is a Superadmin account!
            </span>
          )}
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={() => setShowDeleteConfirm(null)}
            className="px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={() => handleDeleteUser(showDeleteConfirm.id)}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors"
          >
            Delete User
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;